import { useParams } from "react-router-dom";
import { useState, useEffect, useMemo } from "react";
import api from "../services/api";
import { ContainerProduct, ContainerProducts } from "../styles/Layout.style";
import MenuProduct from "../components/MenuProduct/MenuProduct";
import ContentProduct from "../components/ContentProduct/ContentProduct";
import ProductBanner from "../components/ProductBanner/ProductBanner";
import ProductsSlider from "../components/ProductsSilder/ProductsSlider";
import MenuProductMobile from "../components/MenuProductMobile/MenuProductMobile";


const Product = () => {
  const [productLines, setProductLines] = useState({});
  
  const processedProductLines = useMemo(() => {
    const defaultColor = '#A4C8E1';
    return Object.entries(productLines).reduce((acc, [key, value]) => {
      acc[key] = value.map(item => ({...item, color: item.color || defaultColor}));
      return acc;
    }, {});
  }, [productLines]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchLines = async () => {
      try {
        const response = await api.get(`${process.env.REACT_APP_API_URL}/lines`);
        setProductLines(response.data);
        setLoading(false);
      } catch (err) {
        setError(err.message);
        setLoading(false);
      }
    };

    fetchLines();
  }, []);

  const { productId, lineId, subCategory } = useParams();

  if (loading) {
    return <div>Loading...</div>;
  }

  if (error) {
    return <div>Error: {error}</div>;
  }

  return (
    <>
      <ProductBanner lineId={lineId} />
      <ContainerProduct>
        <MenuProduct productLines={processedProductLines[lineId] || []} lineId={lineId} />
        <MenuProductMobile productLines={processedProductLines[lineId] || []} lineId={lineId} />
        <ContentProduct productLines={processedProductLines[lineId] || []} lineId={lineId} subCategory={subCategory}/>
      </ContainerProduct>
      <ContainerProducts>
        <ProductsSlider />
      </ContainerProducts>
    </>
  );
};

export default Product;
